const hardwareringtonedata = [
  {
    id: "1",
    title: "Ringtone 1",
  },
  {
    id: "2",
    title: "Ringtone 2",
  },
  {
    id: "3",
    title: "Ringtone 3",
  },
  {
    id: "4",
    title: "Ringtone 4",
  },
  {
    id: "5",
    title: "Ringtone 5",
  },
];
export default hardwareringtonedata;
